import { useEffect } from "react";

interface JsonLdProps {
  schema: Record<string, unknown> | Record<string, unknown>[];
}

/**
 * Injects a JSON-LD structured data script into <head>.
 * Accepts a single schema object or an array of schemas.
 */
const JsonLd = ({ schema }: JsonLdProps) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, [schema]);

  return null;
};

export default JsonLd;
